

































import { Constants } from '@/constants';
import {BillingTypeEnum, PredicateDefinition, ReportPrintQueryModel, ReportPrintTypeEnum} from '@/libs/Api';
import { createAggregationQueryPayload } from '@/libs/core/+state/models/aggregation-query-payload';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { partiesStore } from '@/libs/parties/+state/store';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { workTaskEvaluationsGroupsStore } from '@/libs/work-task-evaluation-groups/+state/store';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import { workTasksStore } from '@/libs/work-tasks/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator'
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";

@Component({})
export default class Reports extends Page {

}
